import Project from '../components/molecules/Project'
import DashboardLayout from '../components/templates/DashboardLayout'

export const ProjectDetailPage = () => {
  return (
    <DashboardLayout>
      <Project />
    </DashboardLayout>
  )
}
